module.exports = __webpack_public_path__ + "img/explainerdashboard_small.578dbaed.gif";